<template>
  <div>
    <el-drawer
      v-if="visible"
      :visible="visible"
      :title="$l('form_label_store_information') || '店铺信息'"
      direction="rtl"
      :size="900"
      @close="$refs.main.cancel()"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :disabled="disabled"
          :resFabricScmCode="resFabricScmCode"
          :resFabricRecordCode="resFabricRecordCode"
          @close="close()"
        />
      </div>
    </el-drawer>
  </div>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    resFabricScmCode: { type: String, default: '' },
    resFabricRecordCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
      if (!this.disabled) this.$emit('reload')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 20px 32px;
}
</style>
